import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface ItemBaseLetterSpacingOptionProps {
  className?: string;
  letterSpacing: number;
  scaleX: number;
  onChangeLetterSpacing(letterSpacing: number, undoable?: boolean): void;
}

const MIN_LETTER_SPACING = -20;
const MAX_LETTER_SPACING = 500;

export function ItemBaseLetterSpacingOption({className = '', ...props}: ItemBaseLetterSpacingOptionProps): ReactElement<any> | null {
  const updateLetterSpacing = (letterSpacing: number, undoable = true): void => {
    props.onChangeLetterSpacing(letterSpacing, undoable);
  };

  const onChangeHandler = (updatedValue: number): void => {
    updateLetterSpacing(updatedValue / props.scaleX, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateLetterSpacing(updatedValue / props.scaleX);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-letter-spacing"
      className={className}
      value={Math.round(props.letterSpacing * props.scaleX)}
      label={window.i18next.t('pmwjs_letter_spacing')}
      range={{
        min: MIN_LETTER_SPACING,
        max: MAX_LETTER_SPACING,
      }}
      transformDisplay={{
        min: MIN_LETTER_SPACING,
        max: MAX_LETTER_SPACING,
      }}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
    />
  );
}
